<script>
	import Select from './Select.svelte';
	
	export let values;
	export let transitionOptions;
	export let easingOptions;
</script>

<style>
	form {
		display: flex;
		flex-flow: column nowrap;
	}
	
	input[type="range"] {
		max-width: 12rem;
	}
	
	.range-label {
		display: flex;
		white-space: pre-wrap;
	}
	
	section {
		border-radius: 8px;
		border: 1px solid #aeaeae;
		padding: 0.5rem;
		overflow: hidden;
	}
	
	label {
		padding: 0.1rem 0;
	}
</style>
<!-- svelte-ignore a11y-label-has-associated-control -->
<section>
	<slot name="heading" />
<form>
	<label class="range-label" >
		<input 
		  type="range" 
			min=100 
		  max=5000 
		  bind:value={$values.transitionDuration} 
	  />&nbsp;{$values.transitionDuration} ms duration
	</label>
	<label>
	<Select bind:value={$values.transitionName}>
		{#each transitionOptions as transitionName}
		<option value={transitionName}>{transitionName}</option>
		{/each}
	</Select>&nbsp;&nbsp;transition
	</label>
	<label>
  <Select bind:value={$values.easingName}>
		{#each easingOptions as easingName}
		<option value={easingName}>{easingName}</option>
		{/each}
	</Select>&nbsp;&nbsp;easing
	</label>
</form>
</section>